import { format, getTime, formatDistanceToNow } from "date-fns";
import { enGB, pl } from "date-fns/locale";
import { Storage } from "./storage";

const langStorage = Storage.getItem("i18nextLng");

export function fDateMonth(date: Date | string | number) {
    return format(new Date(date), "LLLL yyyy", { locale: langStorage === "pl" ? pl : enGB });
}

export function fDate(date: Date | string | number) {
    return format(new Date(date), "dd MMMM yyyy", { locale: langStorage === "pl" ? pl : enGB });
}

export function fTime(date: Date | string | number) {
    return format(new Date(date), "HH:mm");
}

export function fDateTime(date: Date | string | number) {
    return format(new Date(date), "dd MMM yyyy HH:mm", {
        locale: langStorage === "pl" ? pl : enGB,
    });
}

export function fTimestamp(date: Date | string | number) {
    return getTime(new Date(date));
}

export function fDateTimeSuffix(date: Date | string | number) {
    return format(new Date(date), "dd/MM/yyyy hh:mm p", {
        locale: langStorage === "pl" ? pl : enGB,
    });
}

export function fToNow(date: Date | string | number) {
    return formatDistanceToNow(new Date(date), {
        addSuffix: true,
    });
}
